var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"size":150,"width":5,"color":"primary","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }